// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonWrapper = "CommonLayout__buttonWrapper__-Z2YD";
export const buttons = "CommonLayout__buttons__V-U0Y";
export const commonLayout = "CommonLayout__commonLayout__j3mNB";
export const content = "CommonLayout__content__LtXyp";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "CommonLayout__header__yMTs0";
export const isShrunkSidebar = "CommonLayout__isShrunkSidebar__IPlRi";
export const medium = "500";
export const pushFooter = "CommonLayout__pushFooter__zr+Bc";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";